import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { NavButton } from './components/NavButton';
import { HomePage } from './pages/HomePage';
import { CongressPage } from './pages/CongressPage';
import { RegistrationPage } from './pages/RegistrationPage';
import { AbstractSubmissionPage } from './pages/AbstractSubmissionPage';
import { PresentationUploadPage } from './pages/PresentationUploadPage';
import { SymposiumPage } from './pages/SymposiumPage';
import { SymposiumRegistrationPage } from './pages/SymposiumRegistrationPage';
import { SymposiumPresentationUploadPage } from './pages/SymposiumPresentationUploadPage';
import { SymposiumSubmissionPage } from './pages/SymposiumSubmissionPage';
import { ReviewPage } from './pages/ReviewPage';
import { ELearningPage } from './pages/ELearningPage';
import { KaraokePage } from './pages/KaraokePage';
import { AkademijaPage } from './pages/AkademijaPage';
import { Toaster } from 'react-hot-toast';

function Navigation() {
  const location = useLocation();

  return (
    <div className="bg-gradient-to-b from-blue-600 to-blue-500">
      <div className="bg-gradient-to-r from-blue-600/50 to-blue-400/50">
        <div className="max-w-6xl mx-auto text-center py-4">
          <h1 className="text-2xl font-bold text-white">
            Hrvatsko Društvo onkoloških medicinskih sestara i tehničara
          </h1>
        </div>
        <nav className="p-6">
          <div className="max-w-6xl mx-auto flex justify-center gap-4 flex-wrap">
            <NavButton to="/kongres" active={location.pathname === '/kongres'}>
              Kongres HDOMST 2026
            </NavButton>
            <NavButton to="/tecaj" active={location.pathname === '/tecaj'}>
              Tečaj 1. kategorije
            </NavButton>
            <NavButton to="/" active={location.pathname === '/'}>
              Naslovnica
            </NavButton>
            <NavButton to="/elearning" active={location.pathname === '/elearning'}>
              E-Learning
            </NavButton>
            <NavButton to="/simpozij" active={location.pathname === '/simpozij'}>
              Simpozij HDOMST 2025
            </NavButton>
          </div>
        </nav>
      </div>
    </div>
  );
}

function Layout({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navigation />
      {children}
      <footer className="bg-white border-t py-8 mt-16">
        <div className="max-w-6xl mx-auto px-4 text-center text-gray-600">
          <p>© 2026 HDOMST - Sva prava pridržana</p>
          <p className="mt-2">
            Izradio{' '}
            <a href="#" className="text-blue-500 hover:text-blue-600">
              Studio arena d.o.o.
            </a>
          </p>
        </div>
      </footer>
    </div>
  );
}

export function App() {
  return (
    <>
      <Toaster position="top-right" />
      <Router>
        <Routes>
          <Route path="/akademija" element={<AkademijaPage />} />
          <Route path="*" element={
            <Layout>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/kongres" element={<CongressPage />} />
                <Route path="/program" element={<Navigate to="/kongres#program" replace />} />
                <Route path="/prijava" element={<RegistrationPage />} />
                <Route path="/prijava-sazetka" element={<AbstractSubmissionPage />} />
                <Route path="/upload-prezentacije" element={<PresentationUploadPage />} />
                <Route path="/simpozij" element={<SymposiumPage />} />
                <Route path="/simpozij-registracija" element={<SymposiumRegistrationPage />} />
                <Route path="/simpozij-prijava" element={<SymposiumSubmissionPage />} />
                <Route path="/simpozij-upload-prezentacije" element={<SymposiumPresentationUploadPage />} />
                <Route path="/pregled" element={<ReviewPage />} />
                <Route path="/elearning" element={<ELearningPage />} />
                <Route path="/karaoke" element={<KaraokePage />} />
              </Routes>
            </Layout>
          } />
        </Routes>
      </Router>
    </>
  );
}